$.validator.setDefaults({
    ignore: [],
});

//enables show/hide password whilst typing 
document.addEventListener("DOMContentLoaded", function () {
    // Look for any toggle buttons with .toggle-password
    document.querySelectorAll(".toggle-password").forEach(function (button) {
        button.addEventListener("click", function () {
            // Get the target input (via data-target attribute)
            const inputId = this.getAttribute("data-target");
            const passwordInput = document.getElementById(inputId);

            if (!passwordInput) return;

            const type = passwordInput.getAttribute("type") === "password" ? "text" : "password";
            passwordInput.setAttribute("type", type);

            // Toggle icon/text
            this.textContent = type === "password" ? "👁" : "🙈";
        });
    });
});

$.validator.unobtrusive.adapters.addBool("checkboxrequired", "required");

// Hide the loading screen as soon as the page is styled, rather than on window.load (which also
// waits for every image, iframe, web font and third-party script). The main CSS bundle is linked
// before this bundle, so it has already been applied by the time this runs. Fonts get a short,
// capped wait so the overlay doesn't lift onto the fallback font.
$(function () {
    var hidden = false;
    var hideOnce = function () {
        if (hidden) return;
        hidden = true;
        hideLoadingScreen();
    };

    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(hideOnce, hideOnce);
        setTimeout(hideOnce, 300);
    } else {
        hideOnce();
    }
});

// A page restored from the back/forward cache keeps the overlay a form submit showed
window.addEventListener("pageshow", function (e) {
    if (e.persisted) {
        $(".loading-screen").stop(true, true).hide();
    }
});

$(function () {
    // Standard form submission with validation (forms not on the Turnstile pipeline).
    $('.loading-form').on('submit', function (e) {
        var $form = $(this);
        if ($form.valid()) {
            showLoadingScreen();
        }
    });

    // When the EnableCaptcha kill-switch is off, the partial doesn't render a .cf-turnstile
    // widget, so the Turnstile callback never fires. Each loading-form-turnstile that has
    // no widget on the page needs its submit button enabled immediately on load.
    $(".loading-form-turnstile").each(function () {
        var form = $(this);
        if (form.find('.cf-turnstile').length === 0) {
            form.find("button[type='submit'], input[type='submit']").removeAttr('disabled');
        }
    });

    // Form submission with Cloudflare Turnstile. The widget renders automatically and calls
    // window.onTurnstileSuccess once it has a token; until then the submit button stays disabled.
    //
    // When the kill-switch disables Turnstile, .cf-turnstile is absent and the token-readiness
    // check below is skipped so the submission proceeds normally.
    //
    // We call form.submit() programmatically which re-fires this handler; the
    // 'turnstileSubmitting' data flag short-circuits the second pass so the native browser
    // submission can proceed without re-running our pre-submit checks.
    $(".loading-form-turnstile").on("submit", function (e) {
        var form = $(this);

        if (form.data('turnstileSubmitting')) return;

        e.preventDefault();
        var submitButton = form.find("button[type='submit'], input[type='submit']");

        if (!form.valid()) return;

        var hasTurnstile = form.find('.cf-turnstile').length > 0;
        if (hasTurnstile && !$(".TurnstileToken", form).val()) {
            // Token not ready yet - re-disable and let the Turnstile callback re-enable on success.
            submitButton.attr('disabled', 'disabled');
            return;
        }

        submitButton.attr('disabled', 'disabled');
        showLoadingScreen();
        form.data('turnstileSubmitting', true);
        form.submit();
    });
});

// Cloudflare Turnstile callbacks. Defined globally so the data-callback attributes
// on the .cf-turnstile div can find them.
window.onTurnstileSuccess = function (token) {
    $(".loading-form-turnstile .TurnstileToken").val(token);
    $(".loading-form-turnstile button[type='submit'], .loading-form-turnstile input[type='submit']").removeAttr('disabled');
};
window.onTurnstileError = function () {
    $(".loading-form-turnstile .TurnstileToken").val('');
    $(".loading-form-turnstile button[type='submit'], .loading-form-turnstile input[type='submit']").attr('disabled', 'disabled');
};
window.onTurnstileExpired = function () {
    $(".loading-form-turnstile .TurnstileToken").val('');
    $(".loading-form-turnstile button[type='submit'], .loading-form-turnstile input[type='submit']").attr('disabled', 'disabled');
};

// Custom Field Types
$(document).on('DOMContentLoaded', function () {
    $('.multipleSelectCheckbox').each(function () {
        var noneText = $(this).attr('placeholder') || '-- Select Options --'; // Fallback text if placeholder is not set
        $(this).multiSelect({ 'noneText': noneText });
    });

    RenderSummernoteSimpleByCssClass("textarea-editor", 120);

    new DG.OnOffSwitch({
        el: '.on-off-switch-custom',
        height: 40,
        trackColorOn: '#1B264F',
        trackColorOff: '#666',
        trackBorderColor: '#555',
        textColorOff: '#fff',
        textOn: 'YES',
        textOff: 'NO'
    });

    $('.tagsinput').tagsinput({
        trimValue: true,
        confirmKeys: [13, 44] // Enter or comma
    });
});
// End Custom Field Types

// Summernote is loaded on demand (Frontend/Scripts/ondemand/summernote-lite.js) only by the
// views that use it, so both helpers do nothing when it isn't on the page.
function RenderSummernoteSimpleById(id, height, reset = false) {

    if (!$.fn.summernote) return;

    if (reset) {
        $('#' + id).summernote('reset');
        $('#' + id).summernote('destroy'); 
    }

    $('#' + id).summernote({
        placeholder: '',
        tabsize: 2,
        height: height,
        toolbar: [
            ['font', ['bold', 'underline', 'italic']],
            ['para', ['ul', 'ol']]
        ],
        callbacks: {
            onPaste: function (e) {
                e.preventDefault();

                let clipboardData = (e.originalEvent || e).clipboardData;
                let html = clipboardData.getData('text/html') || clipboardData.getData('text/plain');

                // Clean the pasted content
                let cleanHtml = DOMPurify.sanitize(html, {
                    ALLOWED_TAGS: ['b', 'i', 'u', 'ul', 'ol', 'li', 'p', 'br'],
                    ALLOWED_ATTR: [] // no style/class/etc
                });

                // Insert cleaned HTML via Summernote API
                $(this).summernote('pasteHTML', cleanHtml);
            }
        }
    });
}

function RenderSummernoteSimpleByCssClass(cssClass, height, reset = false) {

    if (!$.fn.summernote) return;

    if (reset) {
        $('.' + cssClass).summernote('reset');
        $('.' + cssClass).summernote('destroy');
    }

    $('.' + cssClass).summernote({
        placeholder: '',
        tabsize: 2,
        height: height,
        toolbar: [
            ['font', ['bold', 'underline', 'italic']],
            ['para', ['ul', 'ol']]
        ],
        callbacks: {
            onPaste: function (e) {
                e.preventDefault();

                let clipboardData = (e.originalEvent || e).clipboardData;
                let html = clipboardData.getData('text/html') || clipboardData.getData('text/plain');

                // Clean the pasted content
                let cleanHtml = DOMPurify.sanitize(html, {
                    ALLOWED_TAGS: ['b', 'i', 'u', 'ul', 'ol', 'li', 'p', 'br'],
                    ALLOWED_ATTR: [] // no style/class/etc
                });

                // Insert cleaned HTML via Summernote API
                $(this).summernote('pasteHTML', cleanHtml);
            }
        }
    });
}

function hideLoadingScreen() {
    $(".loading-screen").fadeOut(200);
}

function showLoadingScreen() {
    const loader = document.querySelector('.loading-screen');
    if (!loader) return;

    // Make sure it's visible again
    loader.style.display = "flex";

    // Grab values from hidden fields
    const backgroundColor = document.getElementById('loading-bg-colour').value || '000000';
    const iconColor = document.getElementById('loading-icon-colour').value || 'FF00AA';
    const iconSize = document.getElementById('loading-icon-size').value || '80';

    loader.style.backgroundColor = `#${backgroundColor}`;
    loader.innerHTML = '';

    const svgNS = "http://www.w3.org/2000/svg";
    const svg = document.createElementNS(svgNS, "svg");
    svg.setAttribute("class", "loader-icon");
    svg.setAttribute("viewBox", "0 0 200 200");
    svg.setAttribute("width", iconSize);
    svg.setAttribute("height", iconSize);

    [40, 100, 160].forEach((cx, i) => {
        const circle = document.createElementNS(svgNS, "circle");
        circle.setAttribute("class", "dot");
        circle.setAttribute("cx", cx);
        circle.setAttribute("cy", 100);
        circle.setAttribute("r", 15);
        circle.setAttribute("stroke-width", 15);
        circle.setAttribute("fill", `#${iconColor}`);
        circle.setAttribute("stroke", `#${iconColor}`);
        circle.style.animation = `blink 2s infinite`;
        circle.style.animationDelay = `${-0.2 * (i + 1)}s`;
        svg.appendChild(circle);
    });

    loader.appendChild(svg);
}